import React, { useRef, useEffect, useState, useContext } from "react";
import Avatar from "../Avatar";
import { baseURL } from "../../utils/axios";
import * as io from "socket.io-client";
import moment from "moment";
import { getUserData } from "../../services/userService";
import ProfileModal from "../ProfileModal";
import {
  getEventImage,
  getPostImageSection,
  getRoomImage,
  renderPostText,
} from "../../utils/utils";
import { StoreContext } from "../../Context/StoreContext";
import { getRoomPosts } from "../../actions/postActions";
import Button from "../Button";
import Loader from "../Loader";

const Post = ({ post, startTime, openUserModal, isRoomBody }) => {
  return post.usersMentioned.length > 1 ? (
    <div className="relative mt-1" key={post._id}>
      <div className="flex items-center py-1">
        <div className="-space-x-3 flex">
          <div className="inline-flex relative overflow-hidden rounded-full border-2 border-white dark:border-navyGray bg-white dark:bg-navyGray">
            <Avatar
              src={getUserData(post.usersMentioned[0]).profile_picture}
              username={getUserData(post.usersMentioned[0]).username}
              size="xs"
            />
          </div>
          <div className="inline-flex relative overflow-hidden rounded-full border-2 border-white dark:border-navyGray bg-white dark:bg-navyGray">
            <Avatar
              src={getUserData(post.usersMentioned[1]).profile_picture}
              username={getUserData(post.usersMentioned[1]).username}
              size="xs"
            />
          </div>
        </div>
        <div className="flex w-full justify-between items-center">
          <div className="pl-4">
            <p className="text-sm font-normal dark:text-frescoWhite">
              <div className="text-gray-700 dark:text-frescoWhite">
                {renderPostText(post, openUserModal, isRoomBody)}
              </div>
            </p>
            <p className="text-xs font-normal text-darkGray">
              {moment(startTime).fromNow()}
            </p>
          </div>
          <>{getEventImage(post)}</>
          <>{getRoomImage(post)}</>
        </div>
      </div>
    </div>
  ) : post.usersMentioned.length > 0 ? (
    <div className="relative mt-1" key={post._id}>
      <div className="flex items-center py-1 z-40">
        <div className="">
          <div className="pl-2">{getPostImageSection(post)}</div>
        </div>
        <div className="flex w-full justify-between items-center">
          <div className="pl-5">
            <p className="text-sm font-normal dark:text-frescoWhite">
              <div className="text-gray-700 dark:text-gray-300">
                {renderPostText(post, openUserModal, isRoomBody)}
              </div>
            </p>
            <p className="text-xs font-normal text-darkGray">
              {moment(startTime).fromNow()}
            </p>
          </div>
          <>{getEventImage(post)}</>
          <>{getRoomImage(post)}</>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};

function ActivityRoom({ roomId, loadMoreButton = false, isRoomBody = false }) {
  const socketRef = useRef();
  const [profileUser, setProfileUser] = useState({});
  const { state, dispatch } = useContext(StoreContext);
  const [activityLoader, setActivityLoader] = useState(true);
  const {
    post: { roomPosts, isMoreRoomPosts, roomOffset, isMoreFetching },
    auth: { user },
  } = state;
  const updateSocketData = ({ queue_room, posts }) => {
    if (posts) {
      setActivityLoader(false);
      dispatch({
        type: "GET_ROOM_POSTS_SUCCESS",
        payload: { posts: posts, offset: 0, loadMore: false },
      });
    }
  };

  const openUserModal = (user) => {
    setProfileUser(user);
  };

  const closeUserModal = () => {
    setProfileUser({});
  };

  useEffect(() => {
    if (roomId) {
      dispatch({ type: "GET_ROOM_POSTS_REQUEST" });
      socketRef.current = io.connect(`${baseURL}/room`);
      socketRef.current.on("connect", () => {
        socketRef.current.emit(
          "join-room",
          {
            roomId: roomId,
            allPost: false,
            userId: user?._id,
            isForRoom: true,
          },
          updateSocketData
        );
      });

      socketRef.current.on("update_call", updateSocketData);
      socketRef.current.on("new_post", updateRoomFeed);
    }
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = undefined;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomId]);
  const updateRoomFeed = ({ post }) => {
    dispatch({ type: "UPDATE_ROOM_POSTS_SUCCESS", payload: post });
  };
  const handleLoadMore = () => {
    getRoomPosts(dispatch, user?.token, isMoreRoomPosts, roomOffset, roomId);
  };

  return (
    <>
      {loadMoreButton && activityLoader ? (
        <Loader />
      ) : (
        <div className="pt-1 ">
          <div className="">
            {roomPosts && roomPosts.length !== 0 ? (
              <div>
                {roomPosts.map((post) => {
                  const startTime = post.createdAt;
                  if ((post.eventsMentioned?.length || 0) > 0) {
                    for (let i = 0; i < post.eventsMentioned.length; i++) {
                      const event = post.eventsMentioned[i];
                      if (!event.is_deleted) {
                        return (
                          <Post
                            post={post}
                            startTime={startTime}
                            openUserModal={openUserModal}
                            isRoomBody={isRoomBody}
                          />
                        );
                      } else {
                        return "";
                      }
                    }
                    return "";
                  } else {
                    return (
                      <Post
                        post={post}
                        startTime={startTime}
                        openUserModal={openUserModal}
                        isRoomBody={isRoomBody}
                      />
                    );
                  }
                })}
                {loadMoreButton ? (
                  !isMoreFetching ? (
                    isMoreRoomPosts && (
                      <div className="flex justify-center">
                        <Button
                          size="vibhut-sm"
                          variant="vibhut-secondary"
                          onClick={handleLoadMore}
                        >
                          Load More
                        </Button>
                      </div>
                    )
                  ) : (
                    <Loader />
                  )
                ) : undefined}
              </div>
            ) : (
              <p className="text-sm font-normal  text-darkGray">
                This room has not beeen active yet.
              </p>
            )}
          </div>
          <ProfileModal
            isOpen={profileUser._id ? true : false}
            setIsOpen={(open) => !open && closeUserModal()}
            user={profileUser}
          />
        </div>
      )}
    </>
  );
}

export default ActivityRoom;
